export default __webpack_public_path__ + "393f9c0a69132914fa9570358f29e2a9.svg";